import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=fc2278b0&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=fc2278b0&prod&lang=scss&scoped=true"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=fc2278b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2278b0",
  null
  
)

export default component.exports